export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/tc-c143034789ea96e493c85faf706b4901.png";